import React from 'react';

const ProgressIndicator = ({ currentStep, totalSteps, steps }) => {
  return (
    <div className="mx-auto w-full max-w-[850px]">
      {/* Step Labels */}
      <div className="flex items-start justify-between">
        {steps.map((step, index) => (
          <div
            key={index}
            className="relative z-10 flex-1 text-center"
          >
            <p
              className={`text-[11px] leading-tight sm:text-[16px] ${
                index === currentStep
                  ? 'text-[#ED6B64]'
                  : index < currentStep
                  ? 'text-black'
                  : 'text-[#e0e0e0]'
              }`}
            >
              {step}
            </p>
          </div>
        ))}
      </div>

      {/* Progress Lines */}
      <div className="mt-2 flex items-center justify-between px-[8%]">
        {Array.from({ length: totalSteps - 1 }).map((_, index) => (
          <div
            key={index}
            className="h-[2px] flex-1"
            style={{
              backgroundColor: index < currentStep ? '#ED6B64' : '#e0e0e0',
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ProgressIndicator;
